export default "__VITE_ASSET__044477e6__"